/**
 * Mapa GameId → klucz sceny Phaser + launch z hubów (§13.3).
 */
import {
  gamesForHub,
  type GameId,
  type MinigameDef,
  type MinigameHub,
} from '@pieskowo/shared';
import { getSceneRouter } from '../core/SceneRouter.js';

/** Klucze scen mini-gier (registry WP0). */
export const GAME_SCENE_KEYS: Record<GameId, string> = {
  rhythm: 'MgRhythm',
  cooking: 'MgCooking',
  runner: 'MgRunner',
  bubbles: 'MgBubbles',
  puzzle: 'MgPuzzle',
  swimrace: 'MgSwimRace',
};

/** Ikony emoji na kafle (zero-reading, placeholdery do WP13). */
export const GAME_ICONS: Record<GameId, string> = {
  rhythm: '🎵',
  cooking: '🦴',
  runner: '🏃',
  bubbles: '🫧',
  puzzle: '🧩',
  swimrace: '🏊',
};

export type HubEntryPoint = 'phone' | 'console';

export function listHubGames(hub: MinigameHub): MinigameDef[] {
  return gamesForHub(hub);
}

/** Start mini-gry z hubu; po Reward wraca wg entryPoint (stuby WP12 czytają data). */
export function launchMinigame(gameId: GameId, entryPoint: HubEntryPoint): void {
  const key = GAME_SCENE_KEYS[gameId];
  if (!key) return;
  const router = getSceneRouter();
  if (entryPoint === 'phone') {
    router.stopOverlay('PhoneOverlay');
  }
  router.go(key, { entryPoint, gameId });
}
